// extracted by mini-css-extract-plugin
export default {"root":"vegaChart_root__DV17F","overlay":"vegaChart_overlay__joOol","vega":"vegaChart_vega__GpMX7"};